import React from 'react';
import { string, number } from 'prop-types';

import { SpinnerImage } from './styles';

export default function Spinner({ color, height, width }) {
  return (
    <SpinnerImage
      color={color}
      height={height}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 50 50'
    >
      <circle cx='25' cy='25' r='20' fill='none' strokeWidth='5' />
    </SpinnerImage>
  );
}

Spinner.defaultProps = {
  color: 'aqua-500',
  height: 50,
  width: 50,
};

Spinner.propTypes = {
  color: string,
  height: number,
  width: number,
};
